import { useState } from "react";
import { Search } from "lucide-react";

export default function TickerSearch({ onSearch, disabled }) {
  const [v, setV] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const s = v.trim().toUpperCase();
    if (s) onSearch(s);
  };
  return (
    <form
      onSubmit={submit}
      className="flex items-center gap-2 border border-white/15 bg-black/40 px-3 py-2 hover:border-white/30 focus-within:border-white transition-colors"
      data-testid="ticker-search-form"
    >
      <Search className="w-4 h-4 text-zinc-500" strokeWidth={2} />
      <input
        type="text"
        value={v}
        onChange={(e) => setV(e.target.value)}
        placeholder="Drill into a ticker  e.g. NVDA"
        disabled={disabled}
        className="bg-transparent outline-none font-mono text-sm tracking-wider text-white placeholder:text-zinc-600 w-40 sm:w-56"
        data-testid="ticker-search-input"
      />
      <button
        type="submit"
        disabled={disabled || !v.trim()}
        className="font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-300 hover:text-white disabled:text-zinc-700"
        data-testid="ticker-search-submit"
      >
        Analyze →
      </button>
    </form>
  );
}
